import React, { useRef } from "react";
import { bool, func, string, arrayOf } from "prop-types";

import { useTranslation } from "@lib/i18n";

import Modal from "../shared/Modal";
import Financing from "../Financing/Financing";

import {
  dealItemType,
  financingCashData,
  financingLLDData,
  financingLOAData,
  financingVACData,
  financingSCFData,
} from "@types";

const FinanceDetailsModal = ({
  isOpen,
  onClose,
  deal,
  cashData,
  lldData,
  loaData,
  scfData,
  vacData,
  journey,
  isB2BSelected,
  withDeliveryInfo,
  errorMessages,
}) => {
  const { t } = useTranslation();

  const modalFirstElement = useRef();

  return (
    <Modal
      isOpen={isOpen}
      firstElement={modalFirstElement}
      ariaLabel={t("price.vac.openDetail")}
      onClose={onClose}
      withCloseIcon
      closeButtonDataId="finance-details-modal-close"
    >
      <Financing
        deal={deal}
        cashData={cashData}
        lldData={lldData}
        loaData={loaData}
        scfData={scfData}
        vacData={vacData}
        journey={journey}
        isB2BSelected={isB2BSelected}
        withDeliveryInfo={withDeliveryInfo}
        errorMessages={errorMessages}
        isModifyVisible={false}
        isReadOnly
        opened
        disabled
        generateContainerId
      />
    </Modal>
  );
};

FinanceDetailsModal.propTypes = {
  isOpen: bool.isRequired,
  onClose: func.isRequired,
  deal: dealItemType,
  cashData: financingCashData,
  lldData: financingLLDData,
  loaData: financingLOAData,
  scfData: financingSCFData,
  vacData: financingVACData,
  journey: string.isRequired,
  isB2BSelected: bool.isRequired,
  withDeliveryInfo: bool,
  errorMessages: arrayOf(string),
};

export default FinanceDetailsModal;
